import React, { useEffect, useRef } from 'react';

const QRCode = ({ url, options }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || !window.QRCodeStyling) return;

    const merged = {
      width: 150,
      height: 150,
      data: url,
      image: "",
      dotsOptions: { type: "rounded", color: "#000000", ...options?.dotsOptions },
      backgroundOptions: { color: "#ffffff", ...options?.backgroundOptions },
      imageOptions: { crossOrigin: "anonymous", margin: 5 },
      qrOptions: { typeNumber: 0, mode: "Byte", errorCorrectionLevel: "M" },
    };

    const qrCode = new window.QRCodeStyling(merged);
    ref.current.innerHTML = '';
    qrCode.append(ref.current);
  }, [url, options?.dotsOptions?.type, options?.dotsOptions?.color, options?.backgroundOptions?.color]);

  return <div ref={ref} />;
};

export default QRCode;
